import { action, toJS, extendObservable } from "mobx";
import dot from "dot-object";
import merge from "deepmerge";

function replaceMerge(destinationArray, sourceArray, options) {
  return sourceArray;
}

class DataStore {
  data = {};
  isDirty = false;

  constructor(options = {}) {
    extendObservable(this, {
      data: {},
      isDirty: false,
      remove: action(this.remove),
      get: action(this.get),
      setArray: action(this.setArray),
      set: action(this.set),
    });

    this.defaultData = options.data || {};
    this.data = Object.assign({}, this.data, { ...this.defaultData });
  }

  clear() {
    this.data = { ...this.defaultData };
  }

  toJS() {
    return toJS(this.data, false);
  }

  clearDirty() {
    this.isDirty = false;
  }

  async remove(key) {
    const newData = this.toJS();
    dot.pick(key, newData);
    const arrayMatch = key.match(/\.([0-9]+)$/);

    if (arrayMatch) {
      const index = arrayMatch[1];
      const parentKey = key.replace("." + index, "");
      const parentElement = dot.pick(parentKey, newData);

      parentElement.splice(index, 1);
    } else {
      dot.del(key, newData);
    }

    this.data = newData;
  }

  get(name) {
    return toJS(dot.pick(name, this.data));
  }

  async setArray(name, value) {
    const oldData = this.toJS();

    this.data = merge(oldData, { [name]: value }, { arrayMerge: replaceMerge });

    this.onSet && this.onSet(name, value);

    this.isDirty = true;
  }

  async set(name, value) {
    const oldData = this.toJS();
    const newData = dot.dot(oldData);

    Object.assign(newData, { [name]: value });

    this.data = merge(oldData, dot.object(newData));

    this.onSet && this.onSet(name, value);

    this.isDirty = true;
  }
}

export default DataStore;
